import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import "../../styles/Contact.css";

const Contact = () => {
  const form = useRef();
  const nameInputRef = useRef();
  const emailInputRef = useRef();
  const subjectInputRef = useRef();
  const messageInputRef = useRef();

  const [errors, setErrors] = useState(false);
  const [statusMessage, setStatusMessage] = useState();
  const [messageLength, setMessageLength] = useState(0);

  const sendEmail = (e) => {
    e.preventDefault();

    // Resetting previous errors if any are present
    setErrors(false);

    // Error handling
    if (
      nameInputRef.current.value === "" &&
      emailInputRef.current.value === "" &&
      messageInputRef.current.value === ""
    ) {
      setErrors({ all: true });
      return;
    }

    if (nameInputRef.current.value === "") {
      setErrors({ name: true });
      return;
    }

    if (emailInputRef.current.value === "") {
      setErrors({ email: true });
      return;
    }

    if (subjectInputRef.current.value === "") {
      setErrors({ subject: true });
      return;
    }

    if (messageInputRef.current.value === "") {
      setErrors({ message: true });
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAIL_SERVICE_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAIL_PUBLIC_ID
      )
      .then(
        () => {
          setStatusMessage({
            status: "success",
            message: "Message successfully sent!",
          });

          nameInputRef.current.value = "";
          emailInputRef.current.value = "";
          subjectInputRef.current.value = "";
          messageInputRef.current.value = "";

          setTimeout(() => {
            setStatusMessage();
          }, 3500);
        },
        () => {
          setStatusMessage({
            status: "fail",
            message: "Request failed. Please try again later.",
          });
        }
      );
  };

  const adjustMessageLengthHandler = (e) => {
    setMessageLength(e.target.value.length);
  };

  return (
    <section tabIndex="0" className="contact" id="contact">
      {statusMessage && (
        <p
          className={`status-message ${
            statusMessage.status === "success" ? "success" : "fail"
          }`}
        >
          <span className="status-icon">
            <i
              className={`${
                statusMessage.status === "success"
                  ? "fa-solid fa-check"
                  : "fa-solid fa-x"
              }`}
            ></i>
          </span>
          {statusMessage.message}
        </p>
      )}
      <div className="contact__intro">
        <h2>Get in touch</h2>
        <div className="underline">
          <div className="heading-underline"></div>
          <div className="heading-underline-end"></div>
        </div>
      </div>
      <div className="contact__main">
        <aside className="contact__aside">
          <div className="contact__aside-main">
            <h2>Let's Talk!</h2>
            <p>
              If you have questions or just want to get in touch, use the form
              and drop me a message. I look forward to hearing from you!
            </p>
          </div>
          <div>
            <div className="contact__aside-socials">
              <a
                href="https://github.com/gillijar"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#fd8c73" }}
              >
                <i className="fa-brands fa-github"></i>
                <p>Github</p>
              </a>
              <a
                href="https://www.linkedin.com/in/jarrod-gilliland/"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#0a66c2" }}
              >
                <i className="fa-brands fa-linkedin"></i>
                <p>LinkedIn</p>
              </a>
            </div>
          </div>
        </aside>
        <form className="contact__form" onSubmit={sendEmail} ref={form}>
          <div className="form-badge">
            <i className="fa-regular fa-envelope"></i>
          </div>
          <div className="contact__form--info">
            <div className="contact__form--inputs">
              <input
                type="text"
                name="user_name"
                placeholder="Name"
                maxLength="30"
                className="form-inputs"
                ref={nameInputRef}
                aria-invalid={errors.name ? "true" : "false"}
                autoComplete="off"
                style={{
                  borderBottom: `${
                    errors.name || errors.all ? "1.5px solid red" : ""
                  }`,
                }}
              />
              <label className="form-label">Name</label>
            </div>
            <div className="contact__form--inputs">
              <input
                type="email"
                name="user_email"
                className="form-inputs"
                placeholder="Email Address"
                ref={emailInputRef}
                aria-invalid={errors.email ? "true" : "false"}
                autoComplete="off"
                style={{
                  borderBottom: `${
                    errors.email || errors.all ? "1.5px solid red" : ""
                  }`,
                }}
              />
              <label className="form-label">Email Address</label>
            </div>
          </div>
          <div className="contact__form--inputs">
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              className="form-inputs"
              ref={subjectInputRef}
              aria-invalid={errors.subject ? "true" : "false"}
              autoComplete="off"
              style={{
                borderBottom: `${
                  errors.subject || errors.all ? "1.5px solid red" : ""
                }`,
              }}
            />
            <label className="form-label">Subject</label>
          </div>
          <textarea
            name="message"
            maxLength="800"
            placeholder="Write your message here"
            className="message-input"
            ref={messageInputRef}
            aria-invalid={errors.message ? "true" : "false"}
            onChange={adjustMessageLengthHandler}
            style={{
              borderBottom: `${
                errors.message || errors.all ? "1.5px solid red" : ""
              }`,
            }}
          />
          <p className="message-chars-left">{800 - messageLength}</p>
          <div className="contact__form--submit">
            <button aria-label="Send email" type="submit">
              Send Message
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;
